import React, { Fragment } from "react";

const Body = ({ renderField, renderSelect, ...props }) => {
    const { deviceNumber, type, organizationId } = props;
    return (
        <Fragment>
            {renderField(deviceNumber)}
            {renderSelect(type)}
            {renderSelect(organizationId)}
        </Fragment>
    );
};

export default Body;
